import { Injectable } from "@angular/core";
import { HttpBackend } from "@angular/common/http";
import { CfgService } from "src/app/cfg/cfg.service";
import { AppLinksCfg, AppLinksCfgService } from "src/app/common/appLinks/appLinksCfg.service";
import { ServerAddressesCfgService } from "src/app/util/serverAddressesCfg.service";

@Injectable({
  providedIn: 'root'
})
export class AppLinksProfessionalsCfgService extends CfgService<AppLinksCfg> {
  json: any = {
    appLinks: [
      {
        resourceId: 199,
        showAsNew: false,
        name: "Clientes",
        link: "%{ClientsApiUrl}",
        iconUrl: "assets/appLinks/professionals/clients@2x.png",
        order: 1,
        group: 0
      },
      {
        resourceId: 1954,
        showAsNew: false,
        name: "Job Orders",
        link: "%{JobOrderFrontUrl}",
        iconUrl: "assets/appLinks/professionals/jobOrders@2x.png",
        order: 2,
        group: 0
      },
      {
        resourceId: 2608,
        showAsNew: false,
        name: "Jobs / servicios",
        link: "%{JobIntakeFrontUrl}",
        iconUrl: "assets/appLinks/professionals/jobInTake@2x.png",
        order: 3,
        group: 0
      },
      {
        resourceId: 197,
        iconUrl: "assets/appLinks/professionals/offers@2x.png"
      },
      {
        resourceId: 499,
        iconUrl: "assets/appLinks/professionals/workers@2x.png"
      },
      {
        resourceId: 200,
        iconUrl: "assets/appLinks/professionals/reports@2x.png"
      },
      {
        resourceId: 3044,
        showAsNew: false,
        name: "Focus Talent Group",
        link: "%{BucketsApiUrl}",
        iconUrl: "assets/appLinks/professionals/buckets@2x.png",
        order: 4,
        group: 1
      },
      {
        resourceId: 206,
        showAsNew: false,
        name: "relevate reference",
        iconUrl: "assets/appLinks/professionals/references@2x.png",
        link: "%{ReferencesProfessionalUrl}",
        order: 9,
        group: 1
      },
      {
        resourceId: 2665,
        showAsNew: false,
        name: "relevate reference",
        iconUrl: "assets/appLinks/professionals/references2@2x.png",
        link: "%{ReferencesApiUrl}",
        order: 9,
        group: 1
      },
      {
        resourceId: 233,
        iconUrl: "assets/appLinks/professionals/adn@2x.png"
      },
      {
        resourceId: 533,
        iconUrl: "assets/appLinks/professionals/gesfico@2x.png"
      },
      {
        resourceId: 2602,
        iconUrl: "assets/appLinks/professionals/payrolls@2x.png"
      },
      {
        resourceId: 1956,
        iconUrl: "assets/appLinks/professionals/billing@2x.png"
      },
      {
        resourceId: -3,
        iconUrl: "assets/appLinks/professionals/eureka@2x.png"
      },
      {
        resourceId: 1724,
        showAsNew: false,
        name: "Candidate Process",
        link: "%{CpsApiUrl}",
        iconUrl: "assets/appLinks/professionals/cps@2x.png",
        order: 7,
        group: 1
      },
      {
        resourceId: 3043,
        showAsNew: false,
        name: "relevate match (ofrecimientos/shortlist)",
        link: "%{TruefitApiUrl}/offering",
        iconUrl: "assets/appLinks/professionals/ofrecimientos@2x.png",
        order: 10,
        group: 1
      },
      {
        resourceId: 3212,
        showAsNew: false,
        name: "Boletines",
        link: "%{TimesheetsFrontUrl}/field",
        iconUrl: "assets/appLinks/professionals/bulletins@2x.png",
        order: 24
      },
      {
        resourceId: 1894,
        showAsNew: false,
        name: "Salary Check",
        link: "%{SalaryCheckFrontUrl}",
        iconUrl: "assets/appLinks/professionals/salaryCheck@2x.png",
        order: 19,
        group: 1
      },
      {
        resourceId: 1955,
        showAsNew: false,
        name: "Configurador RPO",
        link: "%{AdminRpoFrontUrl}",
        iconUrl: "assets/appLinks/professionals/adminRPO@2x.png",
        order: 21,
        group: 3
      },
      {
        resourceId: 7134,
        showAsNew: false,
        name: "Calculadora de tarifas prof",
        link: "%{RateCalculatorFrontUrl}",
        iconUrl: "assets/appLinks/professionals/calcRate@2x.png",
        order: 22,
        group: 3
      },
      {
        resourceId: 2455,
        iconUrl: "assets/appLinks/professionals/visits@2x.png"
      }
    ]
  }

  constructor(httpBackend: HttpBackend, private appLinksCfgService: AppLinksCfgService, private serverAddressesCfgService: ServerAddressesCfgService) {
    super(httpBackend);
  }

  public async initialize(): Promise<void> {
    await this.appLinksCfgService.initialized;
    let baseCfg = this.appLinksCfgService.getCfg();
    await super.initialize();
    let enhancedCfg = this.getCfg();

    let moddedLinks = new AppLinksCfg();
    moddedLinks.appLinks = [];

    await baseCfg.appLinks.asyncForEach(async (baseLink) => {
      let enhancedLink = enhancedCfg.appLinks.find((x) => x.resourceId == baseLink.resourceId);
      if (enhancedLink) {
        moddedLinks.appLinks.push(Object.assign({}, baseLink, enhancedLink));
        enhancedCfg.appLinks.splice(enhancedCfg.appLinks.indexOf(enhancedLink), 1);
      }
    });

    enhancedCfg.appLinks.forEach((x) => {
      moddedLinks.appLinks.push(Object.assign({}, x));
    });

    moddedLinks.appLinks = moddedLinks.appLinks.filter(x => !x.hide);

    this.data = moddedLinks;
  }

  protected getCfgFile(): string {
    return `/cfg/appLinksProfessionals.cfg.json`;
  }

  /**
   * Carga las url en el json
   */
  loadDataUrl() {
    this.replacePlaceholders(this.json, this.serverAddressesCfgService.getData());
  }
}
